<studio-dialog>
  <studio-dialog-title
    text="Are you sure you want to deploy &quot;{{ data.name }}&quot;?"
  ></studio-dialog-title>
  <studio-dialog-buttons-container>
    <studio-dialog-button
      theme="dark-secondary"
      text="Cancel"
      precedence="secondary"
      (click)="cancel()"
    ></studio-dialog-button>
    <studio-dialog-button
      text="Deploy"
      precedence="primary"
      (click)="confirm()"
    ></studio-dialog-button>
  </studio-dialog-buttons-container>
</studio-dialog>
